import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RuncodeState {
	code: string;
	result: string;
	error: string | null;
	isExecuting: boolean;
}

const initialState: RuncodeState = {
	code: '',
	result: '',
	error: null,
	isExecuting: false,
};

const runcodeSlice = createSlice({
	name: 'runcode',
	initialState,
	reducers: {
		setCode: (state, action: PayloadAction<string>) => {
			state.code = action.payload;
		},
		setResult: (state, action: PayloadAction<string>) => {
			state.result = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		setIsExecuting: (state, action: PayloadAction<boolean>) => {
			state.isExecuting = action.payload;
		},
		clearAll: (state) => {
			state.code = '';
			state.result = '';
			state.error = null;
		},
	},
});

export const { setCode, setResult, setError, setIsExecuting, clearAll } =
	runcodeSlice.actions;

export default runcodeSlice.reducer;
